import { createSlice } from '@reduxjs/toolkit'

const reducer = createSlice({
  name: 'dashboard',
  initialState: {
    dashboardFields: []
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload })
  },
}).reducer

const actions = (dis, store, restClient) => {
  return {
    set: (payload) => {
      dis({ type: 'dashboard/set', payload })
    },
    upsert: (payload) => {
      dis({ type: 'dashboard/upsert', payload })
    },
  }
}

export { reducer, actions }
export default { reducer, actions }
